/* GIF-style loops in the dark "Impossible to ignore" section.
   Muted, looping, no controls: reads exactly like a GIF at a fraction of the
   weight. Videos are Shopify-hosted (project rule: never a hand-made WebM);
   Shopify serves an optimised rendition from its CDN.

   TO GO LIVE: upload each clip in Shopify admin → Content → Files, copy the
   file URL, paste it into `src` below. A loop with an empty src is simply not
   shown, so this is safe to publish before the videos are in.

   Posters are WebP frames, so the tile paints instantly. Clips only download
   once they scroll near the viewport, and pause when they leave it. */
(function(){
var C='https://cdn.shopify.com/s/files/1/0979/3604/8475/files/';
var LOOPS=[
{src:'', poster:C+'if-loop-tony-poster.webp', label:'Two Teeth Tony \u00b7 chairlift'},
{src:'', poster:C+'if-loop-instructor-poster.webp', label:'The Instructor \u00b7 first run'}
];

function host(){
var hs=document.querySelectorAll('#if h2');
for(var i=0;i<hs.length;i++){if((hs[i].textContent||'').indexOf('IMPOSSIBLE TO IGNORE')>-1)return hs[i];}
return null;
}

function build(){
if(document.getElementById('if-loops'))return true;
var live=LOOPS.filter(function(l){return !!l.src;});
if(!live.length)return true;
var h=host();if(!h)return false;
var row=document.createElement('div');
row.id='if-loops';
row.setAttribute('style','display:grid; grid-template-columns:repeat('+live.length+',minmax(0,1fr)); gap:10px; max-width:520px; margin:0 auto 22px;');
live.forEach(function(l){
var cell=document.createElement('div');
cell.setAttribute('style','position:relative; border-radius:14px; overflow:hidden; background:#1B222B; aspect-ratio:9/16;');
var v=document.createElement('video');
v.muted=true;v.loop=true;v.playsInline=true;
v.setAttribute('muted','');v.setAttribute('playsinline','');v.setAttribute('preload','none');
v.setAttribute('poster',l.poster);
v.setAttribute('aria-label',l.label);
v.setAttribute('data-src',l.src);
v.setAttribute('style','width:100%; height:100%; object-fit:cover; display:block;');
cell.appendChild(v);
var tag=document.createElement('span');
tag.textContent=l.label;
tag.setAttribute('style','position:absolute; left:8px; bottom:8px; background:rgba(18,22,28,0.72); color:#fff; font-family:Barlow,sans-serif; font-size:11px; font-weight:800; letter-spacing:0.3px; padding:4px 8px; border-radius:999px;');
cell.appendChild(tag);
row.appendChild(cell);
});
h.parentNode.insertBefore(row,h.nextSibling);

var vids=row.querySelectorAll('video');
function load(v){if(!v.src&&v.getAttribute('data-src')){v.src=v.getAttribute('data-src');}}
if('IntersectionObserver' in window){
var io=new IntersectionObserver(function(es){
es.forEach(function(e){
var v=e.target;
if(e.isIntersecting){load(v);var p=v.play();if(p&&p.catch)p.catch(function(){});}
else{v.pause();}
});
},{rootMargin:'200px 0px',threshold:0.25});
for(var i=0;i<vids.length;i++)io.observe(vids[i]);
}else{
for(var j=0;j<vids.length;j++){load(vids[j]);vids[j].play();}
}
return true;
}

var n=0;
var iv=setInterval(function(){n++;if(build()||n>40)clearInterval(iv);},250);
if(document.readyState!=='loading')build();else document.addEventListener('DOMContentLoaded',build);
})();
